module.exports = __webpack_public_path__ + "static/img/pamphlet.e41fbd1.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Tokyo/pamphlet.svg
// module id = /7wi
// module chunks = 0